import { API_JWT_BASE_URL } from '../http'

export const SEARCH_USER_API = `${API_JWT_BASE_URL}/admin/users/search`
export const GET_USER_API = `${API_JWT_BASE_URL}/admin/users/details/`
export const UPDATE_USER_API = `${API_JWT_BASE_URL}/admin/users/`
export const CREATE_USER_API = `${API_JWT_BASE_URL}/Users`
export const GET_ALL_USERNAME_API = `${API_JWT_BASE_URL}/admin/users/getallusername`
export const DELETE_USERS_API = `${API_JWT_BASE_URL}/admin/users`

export const USERS_QUERY_KEYS = {
  SEARCH_USER: 'searchUser',
  GET_USER: 'getUser',
  UPDATE_USER: 'updateUser',
  CREATE_USER: 'createUser',
  GET_ALL_USERNAME: 'getAllUsername',
  DELETE_USERS: 'deleteUsers'
}
